import { initializeApp } from 'firebase/app'
import { getMessaging, isSupported } from 'firebase/messaging'
import config from './config'

const app = initializeApp(config.firebase.web)

// getMessaging() lanza en navegadores sin soporte (Safari/incógnito/sin push);
// resolvemos a null en ese caso para no romper la carga de la app.
export const messagingPromise = isSupported()
  .then(supported => (supported ? getMessaging(app) : null))
  .catch(() => null)
